// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import { roundPrice } from '../../../fnc.js'
import {
	NavLink
} from 'react-router-dom';

const refConst = require("../../../constants.js").v

export default function PMAFromSelection(props){

	const initialState = {
	}

	// const refTitle = useRef(null)

	useEffect(() => {

	}, [])

	let countSection = 4;
	if(props.lineAccess && props.lineAccess.from !== null)
		countSection = 3;

	return (
		<div className="card mb-4 shadow-sm infoBox">
			<div className="card-header bg-dark text-white">
				<div className="d-flex align-items-center">
					<button className="btn btn-light btn-sm mr-2 m-1" onClick={() => {
						window.history.back()
						props.setPage(0)
					}}>
						<i className="bi bi-arrow-left"></i>
					</button>
					<h5 className="card-title mb-0 p-1">
						<i className="bi bi-info-circle mr-2 ml-2"></i>
						PMA Results - {props?.pma?.title}
					</h5>
				</div>
			</div>
			<div className="card-body pb-2">
				<div className={"row g-" + countSection}>
					<div className={"mb-3 col-md-" + countSection}>
						<div className="d-flex align-items-center">
							<div className="mr-3">
								<i className="bi bi-box-seam text-primary" style={{fontSize: '2rem'}}></i>
							</div>
							<div>
								<h6 className="mb-1">Total Items Filled</h6>
								<h3 className="mb-0 text-primary">{props.dataNumberFilled} / {props.dataNumber} ({roundPrice(props.dataNumberFilled / props.dataNumber * 100, 2)}%)</h3>
							</div>
						</div>
					</div>
					<div className={"mb-3 col-md-" + countSection}>
						<div className="d-flex align-items-center">
							<div className="mr-3">
								<i className="bi bi-people text-success" style={{fontSize: '2rem'}}></i>
							</div>
							<div>
								<h6 className="mb-1">Authorized Users</h6>
								<h3 className="mb-0 text-success">{props.accountAccepted.length}</h3>
							</div>
						</div>
					</div>
					<div className={"mb-3 col-md-" + countSection}>
						<div>
							<h6 className="mb-2">Authorized Usernames</h6>
							<div className="d-flex flex-wrap gap-2">
								{props.accountAccepted.length > 0? props.accountAccepted.map((account, index) => (
									<span key={index} className="badge bg-info text-light mr-1">
										<i className="bi bi-person-circle mr-1"></i>
										{account.data_firebase?.email.split("@")[0]}
									</span>
								)) : ""}
							</div>
						</div>
					</div>
					{
						props.lineAccess && props.lineAccess.from !== null? <div className={"mb-3 col-md-" + countSection}>
						<div>
								<h6 className="mb-2">Access</h6>
								<div className="d-flex flex-wrap gap-2">
									{
										<div>
											<span className="badge bg-success text-light mr-1">
												Line from: 
												{props.lineAccess.from} to {props.lineAccess.to}
											</span>
										</div>
									}
								</div>
							</div>
						</div> : ""
					}
					
				</div>
			</div>
		</div>
	);
}